import { ACTIVE_EXPERIMENTAL_TAGS } from '@/lib/constants';
import { useAuth } from '@/state/auth';

const useEnabledDevelopmentTags = () => {
  const activeDevelopmentTag = useAuth(state => state.developmentTag);
  const isDevelopmentTagEnabled = useAuth(
    state => state.isDevelopmentTagEnabled,
  );

  const isGreenPathEnabled = isDevelopmentTagEnabled(
    ACTIVE_EXPERIMENTAL_TAGS.GREEN_PATH,
  );
  // You can add your platform feature here as well if you want
  // so we all can benefit from this hook.

  return {
    activeDevelopmentTag,
    isGreenPathEnabled,
    isDevelopmentTagEnabled,
  };
};

export default useEnabledDevelopmentTags;
